import React from "react";

const RecruitmentCallCenter = () => {
    return (
        <section className="recruitment-area pt-80 pb-80 position-relative overflow-hidden bg-white">
            <div className="container px-1">
                <div className="row align-items-center">
                    {/* Left Column: Title, Description & Cards */}
                    <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
                        {/* Section Header */}
                        <div className="mb-4">
                            <h2 className="fw-bold mb-2" style={{ color: '#0f172a' }}>
                                Recruitment & Call Center Setup
                            </h2>
                            <div className="divider" style={{ width: '40px', height: '4px', backgroundColor: '#2563eb', borderRadius: '2px' }}></div>
                        </div>

                        {/* Description */}
                        <p className="text-muted mb-4" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                            Our operations are powered by a dedicated team of 75+ experienced recruitment consultants and marketing staff.
                        </p>

                        {/* Cards Wrapper */}
                        <div className="d-flex flex-column gap-3">
                            {/* Card 1 */}
                            <div
                                className="p-4 bg-white"
                                style={{
                                    borderRadius: '16px',
                                    border: '1px solid rgba(0, 0, 0, 0.06)',
                                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <div className="d-flex align-items-start gap-3">
                                    <div
                                        className="icon-box text-primary d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                            backgroundColor: '#eff6ff',
                                            borderRadius: '12px',
                                            fontSize: '20px',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="fa fa-headset"></i>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1" style={{ color: '#1e3a8a', fontSize: '18px' }}>
                                            Organized Call Center
                                        </h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                                            Handling thousands of candidate inquiries weekly and conducting initial screenings.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div
                                className="p-4 bg-white"
                                style={{
                                    borderRadius: '16px',
                                    border: '1px solid rgba(0, 0, 0, 0.06)',
                                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <div className="d-flex align-items-start gap-3">
                                    <div
                                        className="icon-box text-primary d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                            backgroundColor: '#eff6ff',
                                            borderRadius: '12px',
                                            fontSize: '20px',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="fa fa-bullhorn"></i>
                                    </div>
                                    <div>
                                        <h5 className="fw-bold mb-1" style={{ color: '#1e3a8a', fontSize: '18px' }}>
                                            Omnichannel Sourcing
                                        </h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                                            Combining digital marketing, social media campaigns, and direct field sourcing across Bangladesh.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Illustration / Image */}
                    <div className="col-lg-6 col-md-12">
                        <div className="text-center position-relative">
                            <img
                                src="65.png"
                                alt="Recruitment & Call Center"
                                className="img-fluid"
                                style={{ maxHeight: '420px', objectFit: 'contain' }}
                                onError={(e) => {
                                    // যদি আপনার কাছে নির্দিষ্ট ইমেজ ফাইল না থাকে তবে এটি ফলব্যাক হিসেবে কাজ করবে বা আপনার সঠিক ইমেজ পাথ বসাতে পারেন
                                    e.target.src = "https://img.freepik.com/free-vector/call-center-operators-working_23-2148492025.jpg";
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RecruitmentCallCenter;